import React, { useState } from "react";
import { useApp } from "../context/AppContext";
import { useBrand } from "../context/BrandContext";
import { Card } from "./ui/card";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { Label } from "./ui/label";
import { Lock } from "lucide-react";

const LABELS = { usine: "Usine", transporteur: "Transporteur", admin: "Administration" };

export const StaffLogin = () => {
  const { role, loginStaff } = useApp();
  const brand = useBrand();
  const [code, setCode] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await loginStaff(code);
    } catch (err) {
      setError("Code d'accès incorrect");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-[60vh] items-center justify-center" data-testid="staff-login">
      <Card className="w-full max-w-sm p-7">
        <div className="mb-4 flex h-12 w-12 items-center justify-center rounded-xl bg-primary/10 text-primary">
          <Lock className="h-6 w-6" />
        </div>
        <p className="text-xs uppercase tracking-[0.2em] text-muted-foreground">Espace protégé</p>
        <h1 className="font-display text-2xl font-extrabold tracking-tight">Accès {LABELS[role] || "personnel"}</h1>
        <p className="mt-1 text-sm text-muted-foreground">
          Réservé au personnel {brand.name}. Saisissez le code d'accès.
        </p>
        <form onSubmit={submit} className="mt-5 space-y-3">
          <div>
            <Label htmlFor="staff-code">Code d'accès</Label>
            <Input
              id="staff-code"
              data-testid="staff-code-input"
              type="password"
              value={code}
              onChange={(e) => setCode(e.target.value)}
              autoFocus
              placeholder="••••••••"
            />
          </div>
          {error && <p className="text-sm text-destructive" data-testid="staff-login-error">{error}</p>}
          <Button type="submit" className="w-full" size="lg" disabled={loading || !code} data-testid="staff-login-btn">
            {loading ? "Vérification..." : "Entrer"}
          </Button>
        </form>
      </Card>
    </div>
  );
};
